import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import DataTable from "../../../../components/DataTable/DataTable";
import { Link } from "react-router-dom";
import DeleteConfirm from '../../../../components/DataTable/DeleteConfirm';
import QueueService from "../../../../services/QueueService/QueueService";
import { alertState, personalizationState, doneListState } from "../../../../recoil-store/recoil-state";
import { useSetRecoilState, useRecoilValue } from 'recoil';
import { convertToDateFormat } from '../../../../helpers/helper';

let deletedIds = [];
let setSelectedRow;
function HistoryMonitor(props) {
    const doneList = useRecoilValue(doneListState);
    const personalization = useRecoilValue(personalizationState);
    const [openDelete, setOpenDelete] = useState(false);
    const setAlert = useSetRecoilState(alertState);

    const {
        loading,
        setSearchKeyData,
        setSearchData,
        searchData,
        setCustomColumn,
        customColumn,
        fetchData,
        setLoading,
    } = props;
    const { t } = useTranslation();

    // useEffect(() => {
    //   fetchData();
    // }, []);

    useEffect(() => {
        setSearchData(doneList);
    }, [doneList]);

    const handleRowsDelete = (rowsDeleted, dataArray, setSelectedRows) => {
        setOpenDelete(true);
        deletedIds = [];
        for (let i of rowsDeleted.data) {
            deletedIds.push(searchData[i.dataIndex].id);
        }
        setSelectedRow = setSelectedRows;
    };

    const deleteHistory = async () => {
        setLoading(true);
        let ids = deletedIds;
        const response = await QueueService.deleteQueues(ids);
        if (response) {
            if (response.status) {
                setSelectedRow([]);
                fetchData('["COMPLETED","CANCELED", "FAILED"]').then(() => true);
            }
            setAlert(alert => ({ ...alert, show: true, message: t('MESSAGES.MONITORING.' + response.message), severity: response.status ? 'success' : 'error' }))
        } else {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
        }
        setLoading(false);
    };

    // const fetchData = async () => {
    //   setLoading(true);
    //   const operationType = localStorage.getItem('pf');
    //   let response;
    //   if (operationType === 'rpa') {
    //     response = await QueueService.getAutomQueueList('["COMPLETED,CANCELED"]');
    //   }  //   else {
    //     response = await QueueService.getIpaasQueueList('["COMPLETED,CANCELED"]');
    //   }
    //   if (response) { setData(response.data); }
    //   setLoading(false);
    // };
    useEffect(() => {
        const column = [
            {
                id: 0,
                name: "id",
                label: " ",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRenderLite: (dataIndex, rowIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return <span>{dataIndex + 1}.</span>;
                        }
                    },
                },
            },
            {
                id: 1,
                name: "name",
                label: t("MESSAGES.MONITORING.AUTOM-NAME"),
                options: {
                    filter: true,
                    sort: true,
                    customBodyRenderLite: (dataIndex, rowIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return (
                                <div>
                                    {
                                        <Link
                                            data-test="credential-link"
                                            to={`/dashboard/monitoring/${searchData[dataIndex].id}`}
                                        >
                                            {searchData[dataIndex]?.name}
                                        </Link>
                                    }
                                </div>
                            );
                        }
                    },
                },
            },
            {
                id: 2,
                name: "operation_status",
                label: t("MESSAGES.MONITORING.OPERATION-STATUS"),
                options: { filter: true, sort: false },
            },
            {
                id: 3,
                name: "run_by",
                label: t("MESSAGES.MONITORING.RUN-BY"),
                options: { filter: true, sort: false },
            },
            {
                id: 4,
                name: "mate_name",
                label: t("MESSAGES.MONITORING.MATE-NAME"),
                options: { filter: true, sort: true },
            },
            {
                id: 5,
                name: "type",
                label: t("MESSAGES.MONITORING.TYPE"),
                options: { filter: true, sort: true },
            },
            {
                id: 6,
                name: "created_at",
                label: t("MESSAGES.MONITORING.STARTED-AT"),
                options: {
                    filter: true,
                    sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return convertToDateFormat(searchData[dataIndex]?.created_at, personalization.date_format);
                        }
                    },
                },
            },
            {
                id: 7,
                name: "completed_at",
                label: t("MESSAGES.MONITORING.ENDED-AT"),
                options: {
                    filter: true,
                    sort: true,
                    display: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return convertToDateFormat(searchData[dataIndex]?.completed_at, personalization.date_format);
                        }
                    },
                },
            },
        ];
        setCustomColumn(column);
        setSearchKeyData(["name", "run_by", "mate_name", "type", "created_at", "completed_at"]);
    }, [searchData]);

    return (
        <div>
            <DataTable
                data={searchData}
                customColumns={customColumn}
                onRowsDelete={handleRowsDelete}
                selectableRows={"multiple"}
                title={t("MESSAGES.MONITORING.AUTOM-MONITORING")}
                loading={loading}
            />
            {openDelete && <DeleteConfirm setOpenDelete={setOpenDelete} message={t("CONTENT.ACTIONEER-PROFILE.DELETE-MESSAGE")} deleteFunc={deleteHistory} />}
        </div>
    );
}

export default HistoryMonitor;
